import React, { useState } from "react";

export interface Status {
  key: string;
  value: string;
  activity_key?: string;
  type: string;
  color: string;
  short_name?: string;
  admin_only?: boolean;
}

interface StatusDropdownProps {
  statuses: Status[];
  currentStatus: string;
  onChange: (newStatus: string) => void;
  viewMode?: "scroll" | "full";
  isAdmin?: boolean; // ← dacă true, arată TOT în dropdown (pt AppointmentsTable)
}

function hexToRGBA(hex: string, opacity: number): string {
  hex = hex.replace("#", "");
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

const StatusDropdown: React.FC<StatusDropdownProps> = ({
  statuses,
  currentStatus,
  onChange,
  viewMode,
  isAdmin = false,
}) => {
  const [open, setOpen] = useState(false);

  // Statusul curent se caută din TOATE statusurile (inclusiv admin_only)
  // → terapeutul VEDE "Penalizare" afișat dacă adminul l-a setat
  const current = statuses.find((st) => st.key === currentStatus);

  // Dropdown-ul de selecție: adminul vede tot, terapeutul nu vede admin_only
  const selectableStatuses = isAdmin
    ? statuses
    : statuses.filter((st) => !st.admin_only);

  const handleSelect = (key: string) => {
    onChange(key);
    setOpen(false);
  };

  return (
    <div className="status-dropdown">
      <div
        className="status-dropdown-selected"
        onClick={() => setOpen((prev) => !prev)}
      >
        {current ? (
          <div
            className="status-selected-bg"
            style={{
              backgroundColor: hexToRGBA(current.color, 0.4),
              color: current.color,
            }}
          >
            <span>
              {viewMode !== "scroll" && current.short_name
                ? current.short_name
                : current.value}
            </span>
          </div>
        ) : (
          <span className="select-status">Selectează status</span>
        )}
      </div>

      {open && (
        <ul className="status-dropdown-list">
          {selectableStatuses.length > 0 ? (
            selectableStatuses.map((st) => (
              <li
                key={st.key}
                className="status-dropdown-item"
                onClick={() => handleSelect(st.key)}
              >
                <div
                  className="status-bullet"
                  style={{ backgroundColor: st.color }}
                />
                <span>{st.value}</span>
              </li>
            ))
          ) : (
            <li className="status-dropdown-item no-status">
              <span style={{ opacity: 0.6, fontStyle: "italic" }}>
                Fără status disponibil
              </span>
            </li>
          )}
        </ul>
      )}
    </div>
  );
};

export default StatusDropdown;